module.exports = "<h1>Unauthorized</h1>\n<p>You are not authorized to view that page</p>";